import { Anchor, CheckSquare, type LucideIcon, Mail, User } from 'lucide-react';
import type { RecentEntityType } from '../../types/command-palette';

/**
 * Presentation for each recordable entity type. Icons live here rather than on the persisted
 * entry because React components aren't serialisable — the store keeps only the `type` string
 * and the renderer looks the icon up on the way out.
 *
 * Keyed by the full RecentEntityType union, so adding a member to that type is a compile error
 * until its icon and label are filled in here.
 */
export const RECENT_ENTITY_META: Record<RecentEntityType, { icon: LucideIcon; label: string }> = {
  contact: { icon: User, label: 'Contact' },
  task: { icon: CheckSquare, label: 'Task' },
  thread: { icon: Mail, label: 'Thread' },
  anchor: { icon: Anchor, label: 'Anchor' },
};
